import { render, staticRenderFns } from "./CompanySetups.vue?vue&type=template&id=dd3c06e2"
import script from "./CompanySetups.vue?vue&type=script&lang=js"
export * from "./CompanySetups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports